export default [
  {
    title: 'Name',
    dataIndex: 'name'
  }
];
